import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';

export default class AdmMapaSitio extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mmsi_Titulo:"",
                mmsi_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mmsi_Id:0,
                mmsi_Titulo:"",
                mmsi_Activo:true
            },
            Validacion: {
                mmsi_Titulo: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mmsi_Titulo: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mmsi_Titulo == '') {              
            newState.Validacion.mmsi_Titulo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloMapaSitioUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mmsi_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mmsi_Titulo = '';

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mmsi_Titulo == '') {              
            newState.ValidacionEdit.mmsi_Titulo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloMapaSitioUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mmsi_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeModulo = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mmsi_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }

    loadModulo = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloMapaSitioUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 67;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeModulo()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mmsi_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                
                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Título" 
                                    value={this.state.resourceEdit.mmsi_Titulo} 
                                    name="mmsi_Titulo"  
                                    className={this.state.ValidacionEdit.mmsi_Titulo.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={300} />
                                </div>

                                <div className="divModulo_Seo">
                                    <h2><strong>Configuración de modulo</strong></h2>
                                    <div className="divWrapperModulo_Seo">
                                        
                                        <div className="txtFile x-2">
                                            <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resourceEdit.pmod_ClaseAncla}  
                                            onChange={this.handleInputChangeEdit}/>
                                        </div>	

                                        <div className="txtFile x-1 ocultarcms">
                                            <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Perfil</option>
                                                {
                                                    this.state.perfiles.length > 0 ?
                                                    this.state.perfiles.map((perfil) => (
                                                        <option value={perfil.id} selected={(this.state.resourceEdit.pmod_Pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>

                                        <div className="txtFile x-1 ocultarcms">
                                            <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Sector</option>
                                                {
                                                    this.state.sectores.length > 0 ?
                                                    this.state.sectores.map((sector) => (
                                                        <option value={sector.id} selected={(this.state.resourceEdit.pmod_Sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>
                                        
                                    </div>
                                </div>



                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    
                                    <div className="textareaResumen x-1">
                                        <input type="text" placeholder="Título" 
                                        value={this.state.resource.mmsi_Titulo} 
                                        name="mmsi_Titulo"  
                                        className={this.state.Validacion.mmsi_Titulo.Error ? "error" : ""}
                                        onChange={this.handleInputChange} 
                                        maxLength={300} />
                                    </div>


                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resource.pmod_ClaseAncla}  
                                                onChange={this.handleInputChange}/>
                                            </div>	

                                            <div className="txtFile x-1 ocultarcms">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1 ocultarcms">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id} key={sector.id}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}